module.exports = __webpack_public_path__ + "static/hackathon-response-61fd58c62be68a51fc5791bd594d9608.jpg";